import { render } from "./InviteProfessional.vue?vue&type=template&id=6d747497"
import script from "./InviteProfessional.vue?vue&type=script&lang=js"
export * from "./InviteProfessional.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__